import React, { Component } from 'react';

class Scrubber extends Component{
	render() {
		return (
			<div className="Scrubber">
				{/* <div className="Scrubber-Progress"></div> */}
			</div>
		)
	}
};

export default Scrubber;


// WEBPACK FOOTER //
// ./src/app/components/Player/Scrubber.js